import React from "react";
import {
  FaPlaneDeparture,
  FaFileContract,
  FaTasks,
  FaQuestionCircle,
  FaDollarSign,
  FaCalendarCheck,
  FaClock,
} from "react-icons/fa";

const CalendarWeekView = ({ currentDate, events, onSelectEvent, onAddEventForDate }) => {
  // Find start of week (Sunday)
  const curr = new Date(currentDate);
  const first = curr.getDate() - curr.getDay();
  const weekDays = [];

  for (let i = 0; i < 7; i++) {
    const next = new Date(curr);
    next.setDate(first + i);
    weekDays.push(next);
  }

  const weekdaysShort = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  const formatDateKey = (d) => {
    const pad = (n) => (n < 10 ? "0" + n : n);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const todayStr = formatDateKey(new Date());

  const eventsByDate = {};
  events.forEach((evt) => {
    if (!evt.start_time) return;
    const dateObj = new Date(evt.start_time);
    if (isNaN(dateObj.getTime())) return;
    const key = formatDateKey(dateObj);
    if (!eventsByDate[key]) eventsByDate[key] = [];
    eventsByDate[key].push(evt);
  });

  const getEventBadgeClass = (evt) => {
    const type = (evt.event_type || "").toLowerCase();
    const source = (evt.module_source || "").toLowerCase();

    if (source === "sales" || type.includes("flight")) return "badge-flight";
    if (source === "documents" || type.includes("expiry")) return "badge-expiry";
    if (source === "tasks" || type.includes("task")) return "badge-task";
    if (source === "inquiries" || type.includes("follow")) return "badge-followup";
    if (source === "invoices" || type.includes("payment")) return "badge-payment";
    return "badge-meeting";
  };

  const getEventIcon = (evt) => {
    const type = (evt.event_type || "").toLowerCase();
    const source = (evt.module_source || "").toLowerCase();

    if (source === "sales" || type.includes("flight")) return <FaPlaneDeparture style={{ fontSize: 10 }} />;
    if (source === "documents" || type.includes("expiry")) return <FaFileContract style={{ fontSize: 10 }} />;
    if (source === "tasks" || type.includes("task")) return <FaTasks style={{ fontSize: 10 }} />;
    if (source === "inquiries" || type.includes("follow")) return <FaQuestionCircle style={{ fontSize: 10 }} />;
    if (source === "invoices" || type.includes("payment")) return <FaDollarSign style={{ fontSize: 10 }} />;
    return <FaCalendarCheck style={{ fontSize: 10 }} />;
  };

  const formatEventTime = (isoStr) => {
    if (!isoStr) return "";
    const d = new Date(isoStr);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  return (
    <div className="week-view-container">
      <div className="week-grid-header" style={{ gridTemplateColumns: "repeat(7, 1fr)" }}>
        {weekDays.map((d, index) => {
          const key = formatDateKey(d);
          const isToday = key === todayStr;
          return (
            <div
              key={index}
              className={`week-header-day ${isToday ? "today" : ""}`}
              onClick={() => onAddEventForDate(d)}
              style={{ cursor: "pointer" }}
              title="Click to schedule on this day"
            >
              <div className="week-day-name">{weekdaysShort[d.getDay()]}</div>
              <div className="week-day-number">{d.getDate()}</div>
            </div>
          );
        })}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", minHeight: "500px" }}>
        {weekDays.map((d, index) => {
          const key = formatDateKey(d);
          const dayEvents = eventsByDate[key] || [];

          return (
            <div
              key={index}
              style={{
                borderRight: index < 6 ? "1px solid #f1f5f9" : "none",
                padding: "12px 8px",
                backgroundColor: key === todayStr ? "#f8fbff" : "#ffffff",
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
            >
              {dayEvents.length === 0 ? (
                <div style={{ textAlign: "center", color: "#cbd5e1", fontSize: 12, marginTop: 40 }}>
                  No items
                </div>
              ) : (
                dayEvents.map((evt) => (
                  <div
                    key={evt.id}
                    className={`month-event-pill ${getEventBadgeClass(evt)}`}
                    onClick={() => onSelectEvent(evt)}
                    style={{
                      padding: "8px 10px",
                      borderRadius: 6,
                      fontSize: 12,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 4,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 6, width: "100%" }}>
                      {getEventIcon(evt)}
                      <span style={{ fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", flex: 1 }}>
                        {evt.title}
                      </span>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, opacity: 0.85 }}>
                      <FaClock style={{ fontSize: 10 }} />
                      <span>{evt.is_all_day ? "All Day" : formatEventTime(evt.start_time)}</span>
                    </div>

                    {evt.client_name && (
                      <div style={{ fontSize: 11, color: "#475569", overflow: "hidden", textOverflow: "ellipsis" }}>
                        Client: {evt.client_name}
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarWeekView;
